import React, { useEffect } from 'react';
import { Form, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Editor } from '../../../components/molecules/Form/components/Editor';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useBlockInteractionContext } from '../../../components/organisms/BlockInteractions/BlockInteractionContext';
import { useDelayed } from '../../../hooks/useDelayed';

function PersonProfileEditHintConfigEdit({ form }: { form: SonForm<any> }) {
  const { t } = useSonTranslation('PersonProfileEditHintConfig');
  const { formProps, params, fetchState } = useForm({ form });
  const editorID = useHtmlValidId();
  const { refresh } = useRefreshBlock();
  const { switchToDefaultView } = useBlockInteractionContext();
  const delayedRefreshAndSwitchToDefault = useDelayed(() => {
    refresh();
    switchToDefaultView();
  });

  useEffect(() => {
    if (fetchState.type === 'success') {
      delayedRefreshAndSwitchToDefault();
    }
  }, [delayedRefreshAndSwitchToDefault, fetchState]);

  const editorParams = params.getByName('son_portal_person_profile_edit_hint_config');

  return (
    <Form {...formProps}>
      <Editor
        id={editorID}
        name={editorParams.name}
        value={editorParams.value}
        constraints={editorParams.constraints}
        autoFocus
        onChange={() => {}}
      />
      <SubmitButton
        buttonLabel={t('Form:save')}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}

export const PersonProfileEditHintConfigEditView = asFetchableView(PersonProfileEditHintConfigEdit);
